<template>
    <v-container>

        <v-row class="mt-10">

            <!-- コンテンツ -->
            <v-col cols="12" sm="6" md="4" v-for="({image, title_sub, title, caption}, i) in $t('LP.contents_in')"
                :key="i">

                <v-card max-width="100%" class="mx-auto" dark elevation="0">
                    <v-img :aspect-ratio="15.9235/10" min-height="200px" :src="image"></v-img>
                    <div class="pa-5">
                        <p class="text-caption mb-1"><small>{{title_sub}}</small></p>
                        <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                            {{title}}</p>
                        <read-more :more-str="$t('LP.contents.more')" :text="caption"
                            :less-str="$t('LP.contents.close')" :max-chars="45" class="text-caption text-pre-wrap" align="left">
                        </read-more>
                    </div>
                </v-card>

            </v-col>

        </v-row>

    </v-container>
</template>


<script>
    export default {

        data() {
            return {
                reveal1: false,
                reveal2: false,
                reveal3: false,
            }
        },


        //カードの文字数制御
        filters: {
            omittedText(text) {
                // 11文字目以降は"…"
                return text.length > 45 ? text.slice(0, 45) + "…" : text;
            },
            omittedText20(text) {
                // 21文字目以降は"…"
                return text.length > 20 ? text.slice(0, 20) + "…" : text;
            }
        },

    }
</script>

<style lang="scss" scoped>
    .v-card {
        height: 100%;
        background: transparent;
    }

    .v-card--reveal {
        bottom: 0;
        opacity: 1 !important;
        position: absolute;
        width: 100%;
    }
</style>